import editSchema from "../../getters/editSchema";

const plantUml = editSchema;
export default plantUml;
